const v = n => `var(${n})`;

export function SkeletonCard() {
  return (
    <div style={{background:v('--surface'),border:`1px solid ${v('--border')}`,borderRadius:'14px',overflow:'hidden'}}>
      <div className="shimmer" style={{height:'140px'}}/>
      <div style={{padding:'10px 12px',display:'flex',flexDirection:'column',gap:'6px'}}>
        <div className="shimmer" style={{height:'10px',width:'60%',borderRadius:'4px'}}/>
        <div className="shimmer" style={{height:'13px',width:'85%',borderRadius:'4px'}}/>
      </div>
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div style={{display:'flex',alignItems:'center',gap:'10px',background:v('--surface'),border:`1px solid ${v('--border')}`,borderRadius:'12px',padding:'8px 10px'}}>
      <div className="shimmer" style={{width:'44px',height:'44px',borderRadius:'8px',flexShrink:0}}/>
      <div style={{flex:1,display:'flex',flexDirection:'column',gap:'6px'}}>
        <div className="shimmer" style={{height:'10px',width:'40%',borderRadius:'4px'}}/>
        <div className="shimmer" style={{height:'12px',width:'70%',borderRadius:'4px'}}/>
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 12 }) {
  return (
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
      {Array.from({length:count}).map((_,i) => <SkeletonCard key={i}/>)}
    </div>
  );
}

export function SkeletonList({ count = 8 }) {
  return (
    <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
      {Array.from({length:count}).map((_,i) => <SkeletonRow key={i}/>)}
    </div>
  );
}
